import { combineReducers } from 'redux';
import list from './List/reducer';
import edit from './Edit/reducer';

const landingSuccessConfigurationReducer = combineReducers({
  list,
  edit,
});

export default landingSuccessConfigurationReducer;
